import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { CreateProposalInput, CreateProposalMutation } from '@/gql/graphql';

const CREATE_PROPOSAL_MUTATION = graphql(`
  mutation CreateProposal($input: CreateProposalInput!) {
    createProposal(input: $input) {
      id
      publicId
    }
  }
`);

const useCreateProposal = (args?: {
  options?: UseMutationOptions<
    CreateProposalMutation,
    unknown,
    CreateProposalInput
  >;
}) => {
  return useMutation({
    mutationFn: (input: CreateProposalInput) => {
      return gqlClient.request(CREATE_PROPOSAL_MUTATION, { input });
    },
    ...args?.options,
  });
};

export default useCreateProposal;
